module.exports = __webpack_public_path__ + "cement/img/组 534@2x.8e22a94c.png";